/**** 黑名单管理 ***/
import axios from 'axios';

/**
 * 查询黑名单列表信息
 * @param params 参数
 * @return {Promise<AxiosResponse<any>>}
 */
export const getList = params => axios.post('/business/blackList/list', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});

/**
 *   黑名单详情
 * @param params
 * @returns {Promise<any | {code: number, message: string}>}
 */
export const detail = params => axios.post('/business/blackList/detail', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});
/**
 * 删除黑名单
 * @param roadPointId 黑名单id
 * @returns {Promise<any | {code: number, message: string}>}
 */
export const del = params => axios.post('/business/blackList/del', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});
/**
 * 创建黑名单
 * @param params 参数
 * @return {Promise<AxiosResponse<any>>}
 */
export const create = params => axios.post('/business/blackList/create', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});

/**
 * 修改黑名单信息信息
 * @param params 参数
 * @return {Promise<AxiosResponse<any>>}
 */
export const update = params => axios.post('/business/blackList/update', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});

/**
 * 导入黑名单
 * @param formData
 * @returns {Promise<any | {code: number, message: string}>}
 */
export const impFile = formData => axios.post('/business/blackList/importFile', formData).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});


export const exportTemplate = () => axios.post('/business/blackList/exportTemplate', null, {
    responseType: 'blob',
    timeout: 20000
}).then(res => res ? res.data : {
    code: 500,
    msg: '服务器无法连接,请稍后重试',
});
